export var cardExpandableBoxStyles = {
  root: function root() {
    return {
      display: 'flex'
    };
  }
};